import React from "react";
import { LinkedinLogo, XLogo, InstagramLogo, FacebookLogo, YoutubeLogo, WhatsappLogo } from "@phosphor-icons/react";

export const SOCIAL_LINKS = [
  { label: "LinkedIn", url: "https://www.linkedin.com/company/maxine-consulting", icon: LinkedinLogo },
  { label: "X", url: "https://twitter.com/maxine_consult", icon: XLogo },
  { label: "Instagram", url: "https://www.instagram.com/maxineconsulting", icon: InstagramLogo },
  { label: "Facebook", url: "https://www.facebook.com/maxineconsulting", icon: FacebookLogo },
  { label: "YouTube", url: "https://www.youtube.com/@maxineconsulting", icon: YoutubeLogo },
  { label: "WhatsApp", url: "https://wa.me/7054986771", icon: WhatsappLogo },
];

export default function SocialLinks({ tone = "dark", size = 18 }) {
  const isDark = tone === "dark";
  return (
    <ul
      data-testid="social-links"
      className="flex flex-wrap items-center gap-2"
      aria-label="Follow Maxine Consulting OPC Private Limited on social media"
    >
      {SOCIAL_LINKS.map((s) => {
        const I = s.icon;
        return (
          <li key={s.label}>
            <a
              href={s.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`social-${s.label.toLowerCase()}`}
              aria-label={s.label}
              title={s.label}
              className={`inline-flex items-center justify-center w-9 h-9 border transition-all duration-200 hover:-translate-y-0.5 ${
                isDark
                  ? "border-[color:var(--line)] text-neutral-700 hover:bg-[color:var(--brand)] hover:text-white hover:border-[color:var(--brand)]"
                  : "border-white/30 text-white/80 hover:bg-white hover:text-[color:var(--brand)] hover:border-white"
              }`}
            >
              <I size={size} weight="bold" />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
